import { render, staticRenderFns } from "./topRight.vue?vue&type=template&id=77beafe6&scoped=true"
import script from "./topRight.vue?vue&type=script&lang=js"
export * from "./topRight.vue?vue&type=script&lang=js"
import style0 from "./topRight.vue?vue&type=style&index=0&id=77beafe6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77beafe6",
  null
  
)

export default component.exports